import { setUpScrollHandler } from './scrollHandler';
import { Editor } from 'ckeditor5';

export class ToolbarManagerWithScrollHandler {
  originalOffset: number | undefined;
  originalPositionStyle: string | undefined;
  originalStyleWidth: string | undefined;
  getToolbarParentElement = (): HTMLElement | null => {
    const toolbarParentElement = document.getElementById('pageHeaderSection');
    return toolbarParentElement;
  };

  getToolbarParentElementWithIndex = (pageHeaderSectionIndex: string): HTMLElement => {
    const toolbarParentElement = document.getElementById(pageHeaderSectionIndex);
    if (toolbarParentElement) {
      return toolbarParentElement;
    }
    throw new Error('could not locate editor toolbar target');
  };

  scrollListener = (): void => {
    const toolbarParent = this.getToolbarParentElement();
    if (toolbarParent === null) {
      return;
    }
    const currentScrollOffset = document.scrollingElement?.scrollTop;
    const toolbarParentOffset = toolbarParent.getBoundingClientRect().top;
    let observed: HTMLElement | null = null;
    const observer = new ResizeObserver((entries) => {
      const parentWidth = entries[0]?.borderBoxSize[0]?.inlineSize;
      const percentage = (parentWidth ?? 0) * 0.99;
      toolbarParent.style.width = `${percentage}px`;
    });

    if (toolbarParentOffset <= 0) {
      observed = toolbarParent.parentElement;
      if (observed) {
        observer.observe(observed);
      }
      toolbarParent.style.position = 'fixed';
      toolbarParent.style.top = '15px';
    } else if (currentScrollOffset && this.originalOffset !== undefined && currentScrollOffset <= this.originalOffset) {
      if (this.originalPositionStyle !== undefined) {
        toolbarParent.style.position = this.originalPositionStyle;
      }

      if (this.originalStyleWidth !== undefined) {
        toolbarParent.style.width = this.originalStyleWidth;
      }

      if (observed) {
        observer.unobserve(observed);
        observed = null;
      }
    }
  };

  setToolbarScrollListener = (): void => {
    const scrollHandler = () => {
      const toolbarParentElement = this.getToolbarParentElement();
      if (toolbarParentElement !== null) {
        this.originalOffset = toolbarParentElement.getBoundingClientRect().top;
        window.addEventListener('scroll', this.scrollListener);
      }
    };

    setUpScrollHandler(scrollHandler);
  };

  setToolbarFromEditor = (editor: Editor): void => {
    const toolbarElement = editor?.ui?.view?.toolbar?.element ?? null;
    const toolbarParentElement = this.getToolbarParentElement();
    if (toolbarParentElement !== null) {
      this.originalOffset = toolbarParentElement.getBoundingClientRect().top;
      this.originalPositionStyle = toolbarParentElement.style.position;
      this.originalStyleWidth = toolbarParentElement.style.width;
      const existingToolbarElements = toolbarParentElement.querySelectorAll('[role="toolbar"]');
      if (toolbarElement && existingToolbarElements.length === 0) {
        this.setToolbarScrollListener();
        toolbarParentElement.insertBefore(toolbarElement, null);
      }
    }
  };

  setToolbarToParentFromEditor = (editor: Editor, pageHeaderSectionIndex: string): void => {
    const toolbarElement = editor?.ui?.view?.toolbar?.element ?? null;
    const toolbarParentElement = this.getToolbarParentElementWithIndex(pageHeaderSectionIndex);
    if (toolbarElement) {
      toolbarParentElement.insertBefore(toolbarElement, null);
    }
  };
}

export const useToolbarManagerWithScrollHandler = (): ToolbarManagerWithScrollHandler =>
  new ToolbarManagerWithScrollHandler();
